/**
 * Resolución de versión de entidad — 3 capas, sin teclear `vX.Y` a mano.
 *
 * El conector-universal NO debe cablear versiones en las rutas canónicas: si el
 * backend versiona una entidad (v2.0 → v2.1) los enlaces hardcodeados se rompen en
 * silencio (root recurrente CRITERIO-VERSION, orden 2aa6ae45 E2E-VERSION-MISMATCH).
 *
 *   1. CATÁLOGO VIVO (`useCatalogStore`): versión real de las entidades EN el scope
 *      del usuario. Primario — captura autobumps §13 a mitad de sesión.
 *   2. MAPA GENERADO EN BUILD (`entity-versions.generated.ts`, desde
 *      cada shared/entidades/<nombre>/definition.json — lo que el backend valida): autoritativo
 *      para entidades FUERA del catálogo scopeado del usuario. Un cliente normal
 *      (no transversal) no ve las entidades chrome/branding (clientes.app.operativa,
 *      clientes.interfaz.publicada, infra.orden-mejora.aplicada…) en /mis-entidades
 *      ni /canonico (ambos RBAC-filtrados), pero SÍ necesita su versión para pintar
 *      su marca / leer sus instancias. El mapa la provee, exacta-a-deploy.
 *   3. `fallback` del caller (compat) o '1.0' — último recurso si una entidad no
 *      existiera en el repo (custom propia sin definition en disco).
 */
import { useCatalogStore } from '@/stores/catalog'
import { versionGenerada } from '@/lib/entity-versions.generated'

/** Versión de una entidad por coords (sub/token/estado). Catálogo vivo → mapa generado → fallback. */
export function vsn(sub: string, token: string, estado: string, fallback?: string): string {
  try {
    const ents = useCatalogStore.getState().entidades
    const e = ents.find((x) => x.sub === sub && x.token === token && x.estado === estado)
    if (e?.version) return e.version
  } catch {
    // store no inicializado (SSR/test) — sigue al mapa generado.
  }
  return versionGenerada(sub, token, estado) || fallback || '1.0'
}
